import { Box, Button, Link, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import AppStoreSrc from "../../assets/AppStore.svg";
import PlayStoreSrc from "../../assets/GooglePlaystore.svg";
import Img from "../../common/Img";

const DownloadButton = ({ shareUrl, ...rest }) => {
  const { buttonStyle } = useStyles();
  return (
    <Link href={shareUrl} target="_blank" rel="noreferrer" underline="none">
      <Button fullWidth variant="contained" disableElevation color="primary" className={buttonStyle} {...rest}>
        <Box display="flex" justifyContent="space-between">
          Order Now - Download ZEEV
          <Box ml={3} mr={1} display="flex">
            <Img src={AppStoreSrc} alt="" width={18} height={18} />
            </Box>
          <Img src={PlayStoreSrc} alt="" width={18} height={18} />
        </Box>
      </Button>
    </Link>
  );
};

DownloadButton.propTypes = {
  shareUrl: PropTypes.string,
};
const useStyles = makeStyles((theme) => ({
  buttonStyle: {
    textTransform: "none",
    fontSize: 13,
    fontWeight: 600,
  },
}));

export default DownloadButton;
